var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SnackbarContent } from '@material-ui/core';
import Snackbar from '@material-ui/core/Snackbar';
import moment from 'moment-timezone';
import * as React from 'react';
import { medicationNotification$ } from '../Config/ApplicationConfig';
import styles from './GlobalSnackbar.module.css';
var MinDisplayTime = 1000;
export var SnackBarVariant;
(function (SnackBarVariant) {
    SnackBarVariant[SnackBarVariant["Normal"] = 0] = "Normal";
    SnackBarVariant[SnackBarVariant["Error"] = 1] = "Error";
})(SnackBarVariant || (SnackBarVariant = {}));
var GlobalSnackbar = /** @class */ (function (_super) {
    __extends(GlobalSnackbar, _super);
    function GlobalSnackbar(props) {
        var _this = _super.call(this, props) || this;
        _this.notifications$$ = null;
        _this.handleClose = function () {
            if (_this.state.messageDisplayTime) {
                var displayTime = moment().diff(moment(_this.state.messageDisplayTime));
                if (displayTime > MinDisplayTime)
                    _this.setState({
                        open: false,
                        variant: SnackBarVariant.Normal,
                        messageDisplayTime: null,
                        message: ''
                    });
            }
            else {
                _this.setState({
                    open: false,
                    variant: SnackBarVariant.Normal,
                    messageDisplayTime: null,
                    message: ''
                });
            }
        };
        _this.displayError = function (message) {
            _this.setState({
                message: message,
                variant: SnackBarVariant.Error,
                messageDisplayTime: new Date(),
                open: true
            });
        };
        _this.displayMessage = function (message) {
            _this.setState({
                message: message,
                variant: SnackBarVariant.Normal,
                messageDisplayTime: new Date(),
                open: true
            });
        };
        _this.state = {
            open: false,
            message: '',
            messageDisplayTime: null,
            variant: SnackBarVariant.Normal
        };
        return _this;
    }
    GlobalSnackbar.prototype.componentDidMount = function () {
        var _this = this;
        this.notifications$$ = medicationNotification$.subscribe(function (notification) {
            if (notification.type === 'display') {
                _this.displayMessage(notification.message);
            }
            else if (notification.type === 'error') {
                _this.displayError(notification.message);
            }
        });
    };
    GlobalSnackbar.prototype.componentWillUnmount = function () {
        if (this.notifications$$) {
            this.notifications$$.unsubscribe();
        }
    };
    GlobalSnackbar.prototype.render = function () {
        var snackBarVariant = '';
        if (this.state.variant === SnackBarVariant.Error) {
            snackBarVariant = styles.errorSnackbar;
        }
        return (React.createElement(React.Fragment, null,
            this.props.children,
            React.createElement(Snackbar, { autoHideDuration: 4000, anchorOrigin: { vertical: 'bottom', horizontal: 'center' }, open: this.state.open, onClose: this.handleClose, ContentProps: {
                    'aria-describedby': 'message-id'
                } },
                React.createElement(SnackbarContent, { message: this.state.message, className: snackBarVariant }))));
    };
    return GlobalSnackbar;
}(React.Component));
export { GlobalSnackbar };
